import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
    root: {},
    section: {
      width: '100%',
      paddingTop: '35px',
      paddingBottom: '35px',
      background: '#242424',
    },
    image: {
      marginTop: '13px',
      width: '140px',
      height: '60px',
      borderTopLeftRadius: '15px',
      borderTopRightRadius: '15px',
      maxWidth: '1628px',
        '@media screen and (max-width: 959px)': {
          width: '110px',
          height: '48px',
      },
    },
    title: {
      fontFamily: 'Arial, sans-serif',
      fontWeight: '400',
      fontSize: '12px',
      color: 'white',
      lineHeight: '18.75px',
      '@media screen and (max-width: 959px)': {
        fontSize: '11px',
      },
    },
    titleCont: {
      width: 'full',
      '@media screen and (max-width: 959px)': {
        width: 'full',
      },
    },
    links: {
      color: '#FFFF !important'
    },
  }));

const FooterHero = () => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.section)}>
        <div className='flex flex-col md:flex-row gap-20 md:gap-48 justify-center mr-40 ml-40 md:mr-64 md:ml-64'>
            <img src='assets/images/logos/logo-horizontal-white.png' alt='logo-iloan' className={clsx(classes.image)} />
              <div className={clsx('flex flex-col gap-20 lg:gap-10 md:gap-20', classes.titleCont)}>
                <h3 className={clsx(classes.title)}>
                    <strong>LEGAL</strong> | <a className={clsx(classes.links)} href='/legal/privacy-policy'>Privacy Policy</a> | <a className={clsx(classes.links)} href='/legal/terms'>Terms of Use</a> | <a className={clsx(classes.links)} href='/legal/licensing'>Disclosures & Licensing</a>
                </h3>
                <h3 className={clsx(classes.title)}>
                    ©2024 iCentral is property of iLoan LLC. All rights reserved. iLoan is a direct lender NMLS ID# 1947845<br/> Headquarters: 2101 W Division St, 60622. 2101 W Division St, 60622.
                </h3>
            </div>
        </div>
    </div>
  )
}

export default FooterHero
